import React, { useState, useEffect } from 'react';
import { Input, Button, Typography, Space } from 'antd';
import { useTheme } from '../context/ThemeContext';
import ResponsiveModal from './workspaceInformation/ResponsiveModal';

const { Paragraph, Text } = Typography;

const MagicLinkConfirmationModal = ({
  isOpen,
  email,
  onConfirm,
  onCancel,
}) => {
  const { theme } = useTheme();
  const [confirmationText, setConfirmationText] = useState('');

  useEffect(() => {
    if (!isOpen) setConfirmationText('');
  }, [isOpen]);

  const isValid =
    confirmationText.trim().toUpperCase() === 'YES' ||
    confirmationText.trim().toUpperCase() === 'SSO';

  const handleConfirm = () => {
    if (!isValid) return;
    onConfirm();
    setConfirmationText('');
  };

  const handleCancel = () => {
    setConfirmationText('');
    onCancel();
  };

  return (
    <ResponsiveModal
      open={isOpen}
      onCancel={handleCancel}
      width={500}
      title="Confirm Magic Link Email"
    >
      <Paragraph style={{ color: theme.textSecondary, marginBottom: 12 }}>
        Do you really want to send email to <Text strong>{email}</Text>? If yes, please type
        &quot;YES&quot; in the text box below.
      </Paragraph>
      <Paragraph style={{ color: theme.textMuted, fontSize: 12, fontStyle: 'italic', marginBottom: 16 }}>
        If it&apos;s for your internal debugging / setup purpose, you can instead take SSO.
      </Paragraph>
      <Input
        value={confirmationText}
        onChange={(e) => setConfirmationText(e.target.value)}
        placeholder="Type YES"
        autoFocus
        onPressEnter={() => {
          if (isValid) handleConfirm();
        }}
        style={{ marginBottom: 20 }}
      />
      <div className="wi-modal-actions">
        <Space wrap style={{ width: '100%', justifyContent: 'flex-end' }}>
          <Button onClick={handleCancel}>Cancel</Button>
          <Button
            type="primary"
            onClick={handleConfirm}
            disabled={!isValid}
            style={{ backgroundColor: isValid ? '#9b59b6' : undefined, borderColor: isValid ? '#9b59b6' : undefined }}
          >
            Send Magic Link
          </Button>
        </Space>
      </div>
    </ResponsiveModal>
  );
};

export default MagicLinkConfirmationModal;
